import React, { useEffect, useState } from "react";

import Table from "../../../shared/table";
import { useTranslation } from "react-i18next";
import { loadingHtml, sucessInfoModal } from "../../../utils/functions";
import useApi from "../../../hooks/useApi";
import Modal from "../../../utils/customModal";
import Checkbox from "../../../shared/custom-components/checkbox";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import { LABELS_ACCOUNT_TYPE } from "../../../shared/AccountTypeSelect";

const AccountApproval = () => {
  const { t } = useTranslation();
  const [pagination, setPagination] = useState({ page: 0, sizePerPage: 10 });
  const [loading, setLoading] = useState(false);
  const { getApiCAll, putApiCAll, cancellCall } = useApi();
  const [data, setData] = useState({});
  const [query, setQuery] = useState("");
  const [allSelect, setAllSelect] = useState(new Set());
  const [selected, setSelected] = useState(new Set());
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  useEffect(() => {
    const { page, sizePerPage } = pagination;
    getList({ page, sizePerPage });
    return () => {
      cancellCall();
    };
  }, []);

  const getList = ({ page, sizePerPage, querystring = null }) => {
    setLoading(true);
    let queryString = querystring !== null ? querystring : query;
    return getApiCAll(
      `/account/pending/approvals-or-rejected?page=${page}&size=${sizePerPage}&sort=updateDate,DESC${queryString}`
    )
      .then((response) => {
        setLoading(false);
        setData(response.data.data);
        setQuery(queryString);
        setPagination({ page, sizePerPage });
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const doApproveOrReject = (data) => {
    setLoading(true);
    return putApiCAll(`/account/approve-or-rejected`, data, {})
      .then((response) => {
        setLoading(false);
        getModalResponse(response.data);
        setSelected(new Set());
        setAllSelect(new Set());
      })
      .catch((err) => {
        setLoading(false);
        getModalResponse(err.response.data);
      });
  };

  const getHeaders = () => {
    const { page } = pagination;
    let headers = [];
    headers.push({
      grow: 0,
      selector: "checkbox",
      name: (
        <Checkbox
          id={`checkbox-${page}`}
          label=""
          name="checkbox"
          onChange={(e) => selectAll(e.target.checked, `page-${page}`)}
          checked={allSelect.has(`page-${page}`)}
        />
      ),
      center: true,
      bodyStyle: { flexGrow: 0 },
      cellFormatter: (row) => (
        <Checkbox
          id={`checkbox-${row.item.id}`}
          label=""
          name="checkbox"
          onChange={(e) =>
            changeSelection(e.target.checked, `id-${row.item.id}`)
          }
          checked={selected.has(`id-${row.item.id}`)}
        />
      ),
    });
    headers.push(
      { selector: "name", name: t("providers.table.headers.company_provider") },
      {
        selector: "businessId",
        name: t("providers.table.headers.identification"),
      },
      {
        selector: "accountType",
        name: t("providers.table.headers.requestType"),
      },
      {
        selector: "account",
        name: t("providers.table.headers.providerAccount"),
      },
      { selector: "updateBy", name: t("providers.table.headers.update_by") }
    );

    return headers;
  };

  const selectAll = (checked, allId) => {
    const tmpSelected = new Set(selected);
    const tmpAllSelect = new Set(allSelect);

    if (checked === false) tmpAllSelect.delete(allId);
    else tmpAllSelect.add(allId);

    data.content.forEach((item) => {
      if (checked === false) tmpSelected.delete(`id-${item.id}`);
      else tmpSelected.add(`id-${item.id}`);
    });

    setAllSelect(tmpAllSelect);
    setSelected(tmpSelected);
  };

  const changeSelection = (check, id) => {
    const tmpSelected = new Set(selected);
    if (check === false) tmpSelected.delete(id);
    else tmpSelected.add(id);
    setSelected(tmpSelected);
  };

  const getData = () => {
    let result = [];
    if (data.content && data.content.length > 0) {
      data.content.map((item) =>
        result.push({
          name: item.companyName,
          businessId: item.customerId,
          account: item.accountNumber,
          accountType:
            LABELS_ACCOUNT_TYPE[item.accountType] || item.accountType,
          updateBy: item.updateBy,
          item,
        })
      );
    }

    return result;
  };

  const getActions = () => {
    const disabled = selected.size === 0;
    return (
      <div className="form-actions clearfix">
        <SecondaryButton
          disabled={disabled}
          onClick={() => masiveApproveOrReject(false)}
        >
          {t("general.buttons.rejected")}
        </SecondaryButton>
        <SecondaryButton
          disabled={disabled}
          onClick={() => masiveApproveOrReject(true)}
        >
          {t("general.buttons.approve")}
        </SecondaryButton>
      </div>
    );
  };

  const getModalResponse = (response) => {
    let detail = "";
    if (response.data[0].success === true) {
      detail = <p>{t("general.successMessage")}</p>;
    } else {
      detail = <p>{response.data[0].message}</p>;
    }

    const button = { formBtn: { text: "Continuar", action: closeAndReset } };
    const content = sucessInfoModal("Admisión de Cuentas", detail, button);
    setModal({ show: true, content, onClose: closeAndReset });
  };

  const closeAndReset = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const masiveApproveOrReject = async (approve) => {
    let data = [];
    selected.forEach((item) => data.push({ approve, id: item.split("-")[1] }));
    try {
      await doApproveOrReject(data);
      getList({ page: 0, sizePerPage: pagination.sizePerPage });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {data?.totalElements != undefined && data?.totalElements > 0 ? (
        <Table
          headers={getHeaders()}
          data={getData()}
          totalSize={data.totalElements}
          sizePerPage={pagination.sizePerPage}
          page={pagination.page}
          onTableChange={getList}
          actions={getActions()}
        />
      ) : (
        <div id="blankAprrovals">
          <img src={noAproval} className="clientImage" />
          <p>
            El sistema no posee admisiones
            <br />
            pendientes.
          </p>
          <div className="line-aproval"></div>
        </div>
      )}

      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
      <Modal show={loading}>{loadingHtml()}</Modal>
    </>
  );
};

export default AccountApproval;
